(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sliding-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", function () {
    const sliding_banner_swiper = new Swiper('#sliding-banner .swiper', {
      loop: false,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '#sliding-banner .swiper-button-next',
        prevEl: '#sliding-banner .swiper-button-prev',
      },
      pagination: {
        el: '#sliding-banner .swiper-pagination',
        type: 'bullets',
        clickable: true,
      }
    });

    const autoplayButton = document.querySelector('.swiper-autoplay-toggle');
    const playIcon = autoplayButton.querySelector(
      '.swiper-autoplay-toggle__play'
    );
    const pauseIcon = autoplayButton.querySelector(
      '.swiper-autoplay-toggle__pause'
    );

    function updateAutoplayButton(isPaused) {
      playIcon.hidden = !isPaused;
      pauseIcon.hidden = isPaused;

      autoplayButton.setAttribute(
        'aria-label',
        isPaused ? 'Start slideshow' : 'Pause slideshow'
      );

      autoplayButton.setAttribute(
        'aria-pressed',
        isPaused ? 'true' : 'false'
      );
    }

    autoplayButton.addEventListener('click', () => {
      if (sliding_banner_swiper.autoplay.running) {
        sliding_banner_swiper.autoplay.stop();
        updateAutoplayButton(true);
      } else {
        sliding_banner_swiper.autoplay.start();
        updateAutoplayButton(false);
      }
    });

    sliding_banner_swiper.on('autoplayStart', () => {
      updateAutoplayButton(false);
    });

    sliding_banner_swiper.on('autoplayStop', () => {
      updateAutoplayButton(true);
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-announcements"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function () {
    const announcementSlider = document.querySelector(
      '#announcement-slider .swiper'
    );

    if (!announcementSlider) return;

    const slideCount = announcementSlider.querySelectorAll(
      '.swiper-slide'
    ).length;

    if (slideCount <= 1) {
      announcementSlider.classList.add('swiper-single-slide');
      return;
    }

    new Swiper(announcementSlider, {
      loop: true,
      a11y: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      allowTouchMove: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      slidesPerView: 1
    });
  });

  } catch(e) { console.error(e); }
})();
})();
